import React, { useEffect, Fragment, useState } from "react"
import { Badge, Container, Table } from "react-bootstrap"
import NavBarUser from "../../components/shared/NavBarUser"
import { withRouter, Link } from "react-router-dom"
import {
	getPeriodosAdmin,
	getUnidadesAdmin,
	deletePeriodo
} from "../../services/admin.service.js"
import Loader from "../../components/shared/Loader"
import {  getDateWithHour } from "../../utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ModalFormPeriodo from "../../components/admin/ModalFormPeriodo"
import { toast } from "react-toastify"
import Title from "./../../components/shared/Title"

const AdminVotacion = () => {
	const [periodos, setPeriodos] = useState([])
	const [unidades, setUnidades] = useState([])
	const [loader, setLoader] = useState()
	const [showModal, setShowModal] = useState(false)
	const [votacionSelected, setVotacionSelected] = useState({})
	const [isEdit, setIsEdit] = useState(false)
	const [loaderDelete, setLoaderDelete] = useState(false)

	const openModalPeriodo = () => {
		console.log("Abriendo modal periodo")
		setVotacionSelected({})
		setIsEdit(false)
		setShowModal(true)
	}

	const isNoEditable = votacion => {
		if (votacion.estado !== "definicion") {
			toast.warning("Solo puede modificar Procesos en Definición")
			return true
		} else {
			return false
		}
	}

	const openModalPeriodoEdit = votacion => {
		if (isNoEditable(votacion)) return

		setIsEdit(true)
		setVotacionSelected(votacion)
		setShowModal(true)
	}

	const confirmDelete = votacion => {
		if (isNoEditable(votacion)) return
		if (votacion.estado !== "definicion")
			return toast.warning("Solo puede editar Procesos en Definición")

		var conf = window.confirm("¿Confirma que desea eliminar este Periodo?")
		if (conf === true) {
			removePeriodo(votacion)
		}
	}

	const removePeriodo = async per => {
		if (isNoEditable(per)) return
		setLoaderDelete(true)
		console.log("borrando periodo")
		const res = await deletePeriodo(per.id)
		if (res?.response === "success") {
			const newArray = periodos.filter(x => x.id !== per.id)
			setPeriodos(newArray)
			toast.info("Periodo eliminado correctamente")
		} else {
			toast.error(res?.message || "Se ha producido un error al eliminar")
		}
		setLoaderDelete(false)
	}

	const getUnidadesAll = async () => {
		const res = await getUnidadesAdmin()
		console.log(res)
		if (res?.response === "success") {
			setUnidades(res.data)
		} else {
			toast.error(res?.message || "No se han cargado correctamente los tipos de unidad")
		}
	}

	const estadoProceso = estado => {
		let tipo = "warning"
		let text = "Definición"
		switch (estado) {
			case "definicion":
				break
			case "abierto":
				tipo = "success"
				text = "Abierto"
				break
			case "cerrado":
				tipo = "danger"
				text = "Cerrado"
				break
			default:
				break
		}

		return (
			<Badge pill variant={tipo}>
				{text}
			</Badge>
		)
	}

	useEffect(() => {
		const getPeriodos = async () => {
			setLoader(true)
			const res = await getPeriodosAdmin()
			console.log(res)
			setPeriodos(res.data)
			setLoader(false)
		}
		if (periodos) {
			getPeriodos()
			getUnidadesAll()
		}
	}, [])

	return (
		<Fragment>
			<NavBarUser />
			<Container className="mt-4">
				<Title title="Periodos de Votación" />

				{loader ? (
					<Loader />
				) : (
					<Table bordered responsive>
						<thead>
							<tr>
								<th>N°</th>
								<th>ID</th>
								<th>ESTADO</th>
								<th>Nombre</th>
								<th>Unidad</th>
								<th>Candidatos</th>
								<th>TRICEL</th>
								<th>Fechas</th>
								<th colSpan="2">Acciones</th>
							</tr>
						</thead>
						<tbody>
							{periodos.map((periodo, index) => {
								return (
									<tr key={index}>
										<td>{index + 1}</td>
										<td>{periodo.id}</td>
										<td className="text-center">{estadoProceso(periodo.estado)}</td>
										<td>{periodo.nombre}</td>
										<td>{periodo.unidad.nombre}</td>
										<td>
											{periodo.candidatos?.map((x, index) => {
												return (
													<span key={index} style={{ fontSize: 85 + "%" }}>
														-{x.nombre} <br />
													</span>
												)
											})}
										</td>
										<td>
											{periodo.periodo_eleccions?.map((x, index) => {
												return (
													<span key={index} style={{ fontSize: 85 + "%" }}>
														-{x.nombres + " " + x.paterno} <br />
													</span>
												)
											})}
										</td>
										<td style={{fontSize: 85+"%"}}>Desde: {getDateWithHour(periodo.desde)} 
										<hr className="my-1"/>
										Hasta: {getDateWithHour(periodo.hasta)}</td>

										<td className="text-center">
											<span
												className="text-primary a-link"
												onClick={() => openModalPeriodoEdit(periodo)}
											>
												<FontAwesomeIcon icon="edit" size="2x" />
											</span>
										</td>
										<td className="text-center">
											<span
												className="text-danger a-link"
												onClick={() => confirmDelete(periodo)}
											>
												<FontAwesomeIcon icon="trash" size="2x" />
											</span>
										</td>
									</tr>
								)
							})}
						</tbody>
					</Table>
				)}
				<hr />
				{loaderDelete ? (
					<Loader />
				) : (
					<span className="btn btn-success" onClick={() => openModalPeriodo()}>
						<FontAwesomeIcon icon="plus" className="mr-2" />
						Nueva Votación
					</span>
				)}
			</Container>
			<ModalFormPeriodo
				show={showModal}
				setShow={setShowModal}
				unidades={unidades}
				setVotaciones={setPeriodos}
				votaciones={periodos}
				votacion={votacionSelected}
				isEdit={isEdit}
			/>
		</Fragment>
	)
}

export default withRouter(AdminVotacion)
